import { useNavigate } from "react-router-dom";
import type { Step } from "@hearing/shared";
import { emitStep } from "../embed.js";

/** Navigate to a step in the self-serve flow. */
export function useFlow() {
  const navigate = useNavigate();
  return {
    go(step: Step) {
      emitStep(step);
      navigate({ pathname: `/${step}`, search: window.location.search });
    },
  };
}
